'use es6';

import http from 'hub-http/clients/apiClient';
import { BASE_URI_LC } from '../constants/ApiConstants';
import { LESSON_API_URL } from './LessonsApi';
const TRACK_API_URL = `${BASE_URI_LC}/tracks`;
export function postTrackEngagment(trackId) {
  return http.post(`${TRACK_API_URL}/${trackId}/conversion`);
}
export function postLessonEngagment(lessonId) {
  return http.post(`${LESSON_API_URL}/${lessonId}/conversion`);
}